import axios from './httpConfig.js'
//******************出入库管理 -- 入库 ******************/
// 入库SN列表
export function GetSNList(param) {
	return axios.post('/admin/receipt/sn/list', param)
}
// 入库单 列表
export function GetOrderList(param) {
	return axios.post('/admin/receipt/order/list', param)
}

// 新增SN入库
export function AddSN(param) {
	return axios.post('/admin/receipt/sn/add', param)
}

// 删除已入库SN
export function DeleteSN(param) {
	return axios.post('/admin/receipt/sn/delete', param)
}

// 删除已入库 整个订单
export function DeleteOrder(param) {
	return axios.post('/admin/receipt/order/delete', param)
}

// 删除已入库 订单中的货品
export function DeleteGoods(param) {
	return axios.post('/admin/receipt/order/goods/delete', param)
}

// 单据的全部信息
export function GetOrderInfo(param) {
	return axios.post('/admin/receipt/order/info', param)
}

// 修改已入库SN
export function EditSN(param) {
	return axios.post('/admin/receipt/sn/edit', param)
} 

// 修改已入库单据主信息
export function EditMainInfo(param) {
	return axios.post('/admin/receipt/order/info/edit', param)
} 

// 修改已入库货位
export function EditGoodsLocation(param) {
	return axios.post('/admin/receipt/order/goods/edit', param)
} 

// 导出入库列表
export function ExportSNList(param) {
	return axios.postBlob('/admin/receipt/sn/export', param)
}
// 导出入库订单列表
export function ExportOrderList(param) {
	return axios.postBlob('/admin/receipt/order/export', param)
}

// 提交导入任务
export function ImportSN(param) {
	return axios.post('/admin/receipt/sn/import', param)
}

// 获取导入任务列表及状态
export function GetImportStatus(param) {
	return axios.post('/admin/receipt/sn/import/task/list', param)
}

// 获取导入任务详情
export function GetImportInfo(param) {
	return axios.post('/admin/receipt/sn/import/task/info', param)
}

// 导出-导入任务失败记录
export function ExportImportWrongList(param) {
	return axios.postBlob('/admin/receipt/sn/export/import/task/error', param)
}

// 根据入库单号分类的入库单_列表
export function GetOrderNumberList(param) {
	return axios.post('/admin/receipt/userdiy/order/list', param)
}

// 读取_根据自定义入库单号分类的入库单_信息
export function GetOrderNumberInfo(param) {
	return axios.post('/admin/receipt/userdiy/order/info', param)
}

export const sockInRequest = {
	GetSNList,
	GetOrderList,
	AddSN,
	DeleteSN,
	DeleteOrder,
	DeleteGoods,
	GetOrderInfo,
	EditSN,
	EditMainInfo,
	EditGoodsLocation,
	ExportSNList,
	ExportOrderList,
	ImportSN,
	GetImportStatus,
	GetImportInfo,
	ExportImportWrongList,
	GetOrderNumberList,
	GetOrderNumberInfo
}